import $ from 'jquery';

import generateFacilityBlock from './generateFacilityBlock';

const renderService = (dataArray) => {
	let blockHtml = '';
	$.each(dataArray, (index, service) => {
		blockHtml += generateFacilityBlock(service);
	});
	$('.section-block.-services > .content').html(blockHtml);
};

export default renderService;



// WEBPACK FOOTER //
// ./src/js/facilities/renderService.js